/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".noise__actions[_ngcontent-%COMP%]{display:flex}#addNoiseButton[_ngcontent-%COMP%]{background-color:#00b6ac}"];
export { styles as styles };
